const e = new URL("../../assets/icon-goto-webstore-DeBPvSI1.png", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=icon-goto-webstore.png.js.map
